import apisauce from 'apisauce';
import ApiMonitor from './apiMonitor';
import AppConfig from '../../config/appConfig';

const save = (configuration, formData) => {
    // define the api
    const configurationApi = apisauce.create({
        baseURL: AppConfig.apiUrl,
        headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: 10000,
        mode: 'no-cors',
    });

    ApiMonitor(configurationApi);
    return configurationApi.put('caravan/configuration', { configuration, formData });
};

const load = (configurationCode) => {
    // define the api
    const configurationApi = apisauce.create({
        baseURL: AppConfig.apiUrl,
        headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: 10000,
        mode: 'no-cors',
    });

    ApiMonitor(configurationApi);

    const configuration = configurationApi.get('caravan/configuration', { configurationCode });

    return {
        configuration,
    };
};

export default {
    save,
    load,
};
